module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAPCAYAAAA/I0V3AAABIElEQVQ4T5XSTytEYRTH8e+vuRprpVhJNngFYzTXlLJgZTkmiRIbL8BbsFSslMKMDBtWdhNDmg1bpSSbSRayk3HnaObOn0s0c5/V0+l8nvP064jAsd1kN1FvGdMsYhRwEI9U7Bx9bmmu+FJtV8NYdmwYnBPQUPChwP0NsarU5VkN2X6in4iKQO8/oFU2b9pHWfcUmGoL/L+VZJn4AHLuOwL1JlnGTSN2wqFsYg20ERJNLIJth0TVqLvuQiE/vUQeFOsQvvuR77kjONwA0bbQWGltxKEbx+wY1PMnlFXA1pW62myi2sRcso+yd4A0/gs+4Vla84XbH7vX3MEcEb7cI2CmXnvgwya1VHht9PyY1IT5pEOpcgEMUvZiWrh+Dk7+Bt1HWD//0nRLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taskPlan/pointEndIcon.png
// module id = itXO
// module chunks = 2